import React, { useEffect, useState } from "react";
import { withSnackbar } from "notistack";

import Loader from "components/Custom/Loader";
import ExcelGrid from "components/Custom/ExcelGrid";

import { LABELS, TITLES } from "common/lables";
import { CRM_REPORTS_APIs } from "apihandlers/crm/reports";
import { API_CONFIG } from "common/config";

const TrainingAssignments = (props: any) => {
  const { setDashMenu } = props;

  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState<any>(null);

  useEffect(() => {
    if (loading) {
      getRows();
    }
  }, [loading]);

  const getRows = async () => {
    try {
      const args = {
        // fromDate: DateFunctions.getDate("thismonth", "from", FORMATS.SQL_DATE),
        // toDate: DateFunctions.getDate("thismonth", "from", FORMATS.SQL_DATE),
        fromDate: "2023-06-01",
        toDate: "2023-06-30",
      };
      const res: any = await CRM_REPORTS_APIs.getTrainingAssignment(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        setRows(list);
        setLoading(false);
      }
    } catch (error) {
      console.error("getTrainingAssignment:", error);
    }
  };

  const COLUMNS = [
    {
      key: "trainingCategory",
      name: "Training Category",
      width: "25%",
      type: "text",
      sortable: true,
      searchable: true,
      editable: false,
    },
    {
      key: "assignedToUser",
      name: "Assigned To",
      width: "15%",
      type: "text",
      sortable: true,
      searchable: true,
      editable: false,
    },
    {
      key: "assignedDate",
      name: "Assigned Date",
      width: "15%",
      type: "text",
      sortable: true,
      searchable: true,
      editable: false,
    },
    {
      key: "completionDate",
      name: "Completion Date",
      width: "15%",
      type: "text",
      sortable: true,
      searchable: true,
      editable: false,
    },
    {
      key: "comments",
      name: "Comments",
      width: "30%",
      type: "text",
      sortable: true,
      searchable: true,
      editable: false,
    },
  ];

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  console.log("selectedRow", rows);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>
            {TITLES.TRAINING_REPORTS}
          </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.TRAINING_ASSIGNMENTS}</li>
        </ul>
        <h4>{TITLES.TRAINING_ASSIGNMENTS}</h4>
        {/* <p>{SUB_TITLES.TRAINING_ASSIGNMENTS}</p> */}
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            height={window.innerHeight * 0.85}
            cols={COLUMNS}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={TITLES.TRAINING_ASSIGNMENTS}
            onReload={reloadGrid}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default withSnackbar(TrainingAssignments);
